export const findLang = (lang) => {
  switch (lang) {
    case 'uz':
      return "O'z";
    case 'ru':
      return 'Ru';
    case 'en':
      return 'En';
    default:
      return "O'z";
  }
};

export const headerTitle = (lang) => {
  switch (lang) {
    case 'uz':
      return <>Test sinovi jarayonlarining onlayn kuzatuvi</>;
    case 'ru':
      return 'Онлайн трансляция процесса сдачи тестовых испытаний';
    case 'en':
      return <>Online surveillance of the test examinations</>;
    default:
      return <>Test sinovi jarayonlarining onlayn kuzatuvi</>;
  }
};

export const headerTitle2 = (lang) => {
  switch (lang) {
    case 'ru':
      return 'Мониторинг тестовых испытаний при поступлении в высшие учебные заведения';
    case 'en':
      return <>Online surveillance of the test examinations to HEI</>;
    default:
      return (
        <>
          Oliy ta’lim muassasalariga o’qishga qabul qilish test sinovi jarayonlarini
          onlayn kuzatuvi
        </>
      );
  }
};

export const headerTitlePresident = (lang) => {
  switch (lang) {
    case 'uz':
      return (
        <>
          Prezident, ijod, ixtisoslashtirilgan maktab va maktab-internatlariga kirish test sinovlari jarayonlarining onlayn kuzatuvi
        </>
      );
    case 'ru':
      return (
        <>
          Онлайн-мониторинг вступительных испытаний в президентские, творческие, специализированные школы и школы-интернаты
        </>
      );
    case 'en':
      return (
        <>
         Online monitoring of test examinations for presidential, creative, specialized schools, and boarding schools.
        </>
      );
    default:
      return (
        <>
          Prezident, ijod, ixtisoslashtirilgan maktab va maktab-internatlariga kirish test sinovlari jarayonlarining onlayn kuzatuvi
        </>
      );
  }
};

export const headerTitleMobile = (lang) => {
  switch (lang) {
    case 'uz':
      return "Test sinovi jarayonlarining onlayn kuzatuvi ";
    case 'ru':
      return 'Онлайн трансляция процесса сдачи тестовых испытаний';
    case 'en':
      return 'Online surveillance of the HEI admission test examinations';
    default:
      return "Online monitoring of the admission tests";
  }
};

export const headerTitlePresidentMobile = (lang) => {
  switch (lang) {
    case 'uz':
      return 'Prezident, ijod, ixtisoslashtirilgan maktab va maktab-internatlariga kirish test sinovlari jarayonlarining onlayn kuzatuvi';
    case 'ru':
      return 'Вступительные экзамены в Президентские школы. Онлайн трансляция процесса сдачи тестовых испытаний ';
    case 'en':
      return 'Admission exams to presidential schools. Online surveillance of the test examinations';
    default:
      return 'Prezident, ijod, ixtisoslashtirilgan maktab va maktab-internatlariga kirish test sinovlari jarayonlarining onlayn kuzatuvi';
  }
};
